<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="设备处置记录"
      edit-title
      id-key="DisposalRecordsId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="over"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">     
            <el-form-item label="单据日期">
              <el-date-picker
                v-model="data.RecordDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单据编码" prop="RecordNo">
              <!-- <el-input v-model="data.RecordNo" placeholder="请输入单据编码" /> -->
              <span v-if="Mode == 0" class="detail-span">{{
                data.RecordNo
              }}</span>
              <el-input
                v-else
                v-model="data.RecordNo"
                placeholder="请输入类别编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处置方式" prop="DisposalType">
              <el-select v-model="data.DisposalType">
                <el-option value="出售" label="出售"></el-option>
                <el-option value="报废" label="报废"></el-option>
                <el-option value="赠送" label="赠送"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="row-tb-head" style="margin-top: 10px">
          <span>设备列表</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
            <!-- <el-button type="danger" @click="del">删除</el-button> -->
          </div>
        </div>
        <el-table
          ref="table"
          class="table-line tb-c-head"
          @selection-change="handleSelectionChange"
          :data="facList"
          border
        >
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column label="设备编码" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.EquipmentNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.EquipmentName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-input
                type="number"
                v-model="row.Quantity"
                @change="updateCount($event, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.UnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click.native="del(row, $index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </common-dialog>
    <facility-dialog
      ref="facilityDialog"
      in-dialog
      selectable
      @select="setFac"
    ></facility-dialog>
    <manage-select
      ref="manageSelect"
      in-dialog
      selectable
      multiple
      @select-multiple="setManage"
    ></manage-select>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import facilityDialog from "@/components/facility/manage/listDialog";
import manageSelect from "@/components/facility/manage/listDialog.vue";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    facilityDialog,
    manageSelect,
  },
  data() {
    return {
      data: {
        DisposalRecordsId: 0,
        RecordNo: "",
        RecordDate: this.$commonJs.getToday(),
        DisposalType: null,
        DetailDtos: [],
      },
      index: null,
      facList: [],
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/disposalRecords").default,

      showList: [],
      rules: {
        DisposalType: [{ required: true, message: "请选择处置方式" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    onCreateOpened() {
      this.code_api.previewNo("设备处置单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.RecordNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取设备处置单编码失败");
        }
      });
    },
    onEditOpened(data) {
      this.api.info(data.DisposalRecordsId).then((res) => {
        this.data = res.Data;
        this.facList = res.Data.DetailDtos.map((i) => ((i.T = 3), i));
      });
    },
    updateCount(data, index) {
      if (this.facList[index].T === 3) this.facList[index].T = 1;
    },
    onBeforeSave() {
      if (this.data.DetailDtos.length == 0) {
        this.data.DetailDtos = this.facList.map((item) => ((item.T = 0), item));
      } else {
        let delIds = this.facList.map((item) => item.EquipmentId);
        let delList = this.data.DetailDtos.reduce((arr, item) => {
          if (!delIds.includes(item.EquipmentId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let addIds = this.data.DetailDtos.map((item) => item.EquipmentId);
        let addList = [];
        addList = this.facList.reduce((arr, item) => {
          if (!addIds.includes(item.EquipmentId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);

        let updateList = this.facList.filter((item) => item.T === 1);
        this.data.DetailDtos = [...addList, ...delList, ...updateList];
      }
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    add() {
      this.$refs.manageSelect.open().then((that) => that.getData());
    },
    setManage(data) {
      console.log("data", data);
      const Ids = this.facList.map((i) => i.EquipmentId) ?? [];
      const addList = data.reduce((acc, item) => {
        if (!Ids.includes(item.EquipmentId)) acc.push({ T: 0, ...item });
        return acc;
      }, []);
      this.facList = [...this.facList, ...addList];
    },
    openFacility(data) {
      this.index = data;
      this.$refs.facilityDialog.open().then((that) => that.getData());
    },
    setFac(data) {
      console.log(data);
      this.facList[this.index].value2 = data.JobName;
      this.index = null;
    },
    del(data, index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.facList.splice(index, 1);
        })
        .catch(() => {});
    },

    over() {
      this.facList = [];
      this.showList = [];
    },
  },
};
</script>
